
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { TFAQItem } from "apiTypes";
import CustomContentLoader from "components/ReuseableCompos/CustomContentLoader";
import { API_URL } from "config";
import useMobile from "customHooks/useMobile";
import StaticLayout from "layout/StaticLayout";
import { GetStaticProps } from "next";
import { useRouter } from "next/router";
import { AboutLayoutProps } from "pages/about";
import { getData } from "utils/getData";
import ProfileMenuItem from "../../../components/Profile/ProfileMenuItem";
import { TContents } from "../../../customHooks/useContents";
export type FaqsLayoutProps = {
    faqs?: {
        key: string;
        name: string;
        description: string;
    }[];
    questions: TFAQItem[];
} & AboutLayoutProps;
const FAQs: React.FC<FaqsLayoutProps> = ({ faqs }) => {
    // const conts = useContents();
    const { push } = useRouter();
    const isMobile = useMobile("md");
    const defArr = [1, 2, 3, 4, 5];
    if (!faqs) {
        return (<>
        {defArr.map((_, i) => (<FaqSkeleton key={i} isMobile={isMobile}/>))}
      </>);
    }
    else {
        return (<div className="d-flex flex-column align-items-center justify-content-center list-group list-group-flush h-100">
        {faqs.map((item) => (<ProfileMenuItem key={item.key} title={item.name} desc={item.description} icon={"fe-book"} href={`/help/faqs/${item.key}`}/>))}
      </div>);
    }
};
export default FAQs;
(FAQs as any).Layout = StaticLayout;
const getStaticProps: GetStaticProps<FaqsLayoutProps> = async ({ locale, }) => {
    const loc = locale === "default" ? "ar" : locale;
    // const conts: TContents = await JSON.parse(
    //   await fs.readFile(
    //     path.join(process.cwd(), "constants", `contents-${loc}.json`),
    //     "utf8"
    //   )
    // );
    const res = await getData<TContents>(`${API_URL}/contents`, null, {
        locale: loc
    });
    const conts = res.data;
    const layoutData: AboutLayoutProps["pages"] = conts.pages.map((page) => ({
        slug: page.slug,
        title: page.contents.title,
        description: page.contents.description
    }));
    return {
        props: {
            pages: layoutData,
            faqs: conts.faqs.map((faq) => ({
                key: faq.key,
                name: faq.name,
                description: faq.description
            })),
            questions: []
        },
        revalidate: 1800
    };
};
const FaqSkeleton = ({ isMobile }) => {
    const styles = {
        vb: isMobile ? "0 0 400 120" : "0 0 800 80"
    };
    return (<CustomContentLoader viewBox={styles.vb}>
      <rect x="80" y={isMobile ? "24" : "8"} rx="4" ry="4" width={isMobile ? "161" : "260"} height="28"/>
      <rect x="80" y={isMobile ? "64" : "42"} rx="4" ry="4" width={isMobile ? "262" : "400"} height="22"/>
      <rect x="0" y={isMobile ? "116" : "72"} rx="4" ry="4" width={isMobile ? "400" : "800"} height="1"/>
      <rect x="16" y={isMobile ? "30" : "15"} rx="8" ry="8" width={isMobile ? "48" : "40"} height={isMobile ? "48" : "40"}/>
    </CustomContentLoader>);
};

    async function __Next_Translate__getStaticProps__197cac823d2__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/help/faqs/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197cac823d2__ as getStaticProps }
  